// src/router/index.js
import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import store from "@/state/store";
import routes from "./routes";
import { getAllowedRoutes } from "./permissions";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: "page",
});

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});

router.beforeEach((routeTo, routeFrom, next) => {
  console.log(
      "Navigating to:",
      routeTo.path,
      "Logged in:",
      store.getters["auth/loggedIn"]
  );
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  // If route doesn't require auth, allow access
  if (!authRequired) {
    return next();
  }

  // If user is not logged in, redirect to login
  if (!store.getters["auth/loggedIn"]) {
    console.log("Not logged in, redirecting to /login");
    return next({
      name: "login",
      query: { redirectFrom: routeTo.fullPath },
    });
  }

  // User is logged in, check permissions
  const user = store.getters["auth/loggedInUser"];
  const allowedRoutes = getAllowedRoutes(user?.permissions || []);
  console.log("Allowed routes:", allowedRoutes);

  // If the requested route is allowed, proceed
  if (allowedRoutes.includes(routeTo.path)) {
    return next();
  }

  // Unauthorized access, redirect to home
  console.log("Unauthorized access to:", routeTo.path, "Redirecting to /");
  return next({ name: "home" });
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  next();
});

export default router;